export default "__VITE_ASSET__CxmOydl3__"